<div class="ongoing-meeting" [class.is-expanded]="isExpanded" [class.highlight]="useHighlight">
  <div class="details">
    <div class="name hide-when-minimized" [matTooltip]="meeting.name" matTooltipClass="mask-meeting-name">{{ meeting.name }}</div>
    @if (statusMessage !== null) {
      <div class="status-container">
        @if (displayStatusButtons && meeting.latestMeetingSession !== null) {
          @if (meeting.latestMeetingSession.status === 'CONNECTED') {
            <mat-icon class="icon state-icon recording-icon" fontIcon="radio_button_checked"></mat-icon>
            <mat-icon
              class="icon action-icon"
              fontIcon="pause"
              [matTooltip]="'MEETINGS.ONGOING_MEETINGS.RECORDING_PAUSE.TITLE' | translate"
              (click)="pauseRecording(meeting)"
            ></mat-icon>
          } @else if (meeting.latestMeetingSession.status === 'PAUSED') {
            <mat-icon class="icon state-icon" fontIcon="pause"></mat-icon>
            <mat-icon
              class="icon action-icon"
              fontIcon="play_arrow"
              [matTooltip]="'MEETINGS.ONGOING_MEETINGS.RECORDING_RESUME.TITLE' | translate"
              (click)="resumeRecording(meeting)"
            ></mat-icon>
          }
        }
        <span class="status hide-when-minimized">{{ statusMessage }}</span>
      </div>
    }
    @if (displayExtendIconButton) {
      <div class="recording-stops">
        <div
          class="recording-stops-minimized show-when-minimized"
          [matTooltip]="'MEETINGS.ONGOING_MEETINGS.RECORDING_STOPS.TOOLTIP' | translate: { time: recordingStopsAtLabel }"
        >
          <mat-icon class="countdown-icon" fontIcon="timer"></mat-icon>
          <span>{{ recordingRemaining }}</span>
        </div>
        <div class="recording-stops-expanded hide-when-minimized">
          <span
            [matTooltip]="'MEETINGS.ONGOING_MEETINGS.RECORDING_STOPS.TOOLTIP' | translate: { time: recordingStopsAtLabel }"
            [innerHtml]="'MEETINGS.ONGOING_MEETINGS.RECORDING_STOPS.LABEL' | translate: { time: recordingRemaining }"
          ></span>
          <button mat-icon-button mat-small-icon-button [matTooltip]="'MEETINGS.EXTEND_STAY.CARD_BUTTON' | translate" (click)="extend(meeting)">
            <mat-icon>more_time</mat-icon>
          </button>
        </div>
      </div>
    }
    @if (displaySkipToNextSubMeetingButton) {
      <div class="sub-meeting-container">
        <mat-icon
          class="icon action-icon skip-button"
          fontIcon="double_arrow"
          [matTooltip]="'MEETINGS.ONGOING_MEETINGS.PROCEED_TO_NEXT_SUB_MEETING.TITLE' | translate"
          (click)="switchToNextSubMeeting(meeting)"
        ></mat-icon>
        <span>
          <span class="hide-when-minimized">{{ 'MEETINGS.ONGOING_MEETINGS.SUB_MEETING' | translate }}</span>
        </span>
        <span> #{{ meeting.totalNumberOfSplits + 1 }} </span>
      </div>
    }
    @if (meeting.currentParticipantCount !== null) {
      <div class="participants-container hide-when-minimized" [matTooltip]="currentParticipantText">
        <mat-icon fontIcon="group"></mat-icon>
        <div class="participant-text">
          {{ currentParticipantText }}
        </div>
      </div>
    }
  </div>
  <div class="buttons">
    <div class="top-buttons">
      <button
        mat-icon-button
        class="hang-up-button"
        color="accent"
        [disabled]="meeting.latestMeetingSession === null"
        [matTooltip]="'COMMON.HANG_UP' | translate"
        (click)="hangUp(meeting)"
      >
        <mat-icon>phone_disabled</mat-icon>
      </button>
    </div>
    <div class="bottom-buttons hide-when-minimized">
      @if (canJoinNow) {
        <button mat-icon-button [matTooltip]="'MEETINGS.JOIN_IMMEDIATELY.BUTTON_TOOLTIP' | translate" (click)="joinNow(meeting)">
          <mat-icon fontSet="material-symbols-outlined" style="transform: rotate(180deg)">start</mat-icon>
        </button>
      }
      <button mat-icon-button [matMenuTriggerFor]="menu" (menuOpened)="menuOpened.emit()" (menuClosed)="menuClosed.emit()">
        <mat-icon>more_horiz</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item translate="COMMON.JOIN" (click)="join(meeting)"></button>
        <button mat-menu-item translate="COMMON.HANG_UP" (click)="hangUp(meeting)"></button>
        @if (canJoinNow) {
          <button mat-menu-item translate="MEETINGS.JOIN_IMMEDIATELY.BUTTON_TOOLTIP" (click)="joinNow(meeting)"></button>
        }
        @if (meeting.latestMeetingSession !== null) {
          @if (meeting.latestMeetingSession.status === 'CONNECTED') {
            <button mat-menu-item translate="MEETINGS.ONGOING_MEETINGS.RECORDING_PAUSE.TITLE" (click)="pauseRecording(meeting)"></button>
          } @else if (meeting.latestMeetingSession.status === 'PAUSED') {
            <button mat-menu-item translate="MEETINGS.ONGOING_MEETINGS.RECORDING_RESUME.TITLE" (click)="resumeRecording(meeting)"></button>
          }
        }
        @if (displayExtendButton) {
          <button mat-menu-item translate="MEETINGS.EXTEND_STAY.CARD_BUTTON" (click)="extend(meeting)"></button>
        }
        @if (displaySkipToNextSubMeetingButton) {
          <button mat-menu-item translate="MEETINGS.ONGOING_MEETINGS.PROCEED_TO_NEXT_SUB_MEETING.TITLE" (click)="switchToNextSubMeeting(meeting)"></button>
        }
        <a [routerLink]="['/app', 'meetings', meeting.id, 'setup']" queryParamsHandling="merge">
          <button mat-menu-item translate="COMMON.MEETING_INFO"></button>
        </a>
      </mat-menu>
    </div>
  </div>
</div>
